export default function CustomSliderDot({ outerCircleColor = "white" }) {
  return (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
      <circle cx="8" cy="8" r="4" fill="currentColor" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16Zm0-2A6 6 0 1 0 8 2a6 6 0 0 0 0 12Z"
        fill={outerCircleColor}
      />
    </svg>
  )
}
